import { useRef, useEffect, useLayoutEffect } from 'react';
import { isSsr } from './util.js';

/* Importing useLayoutEffect is allowed here as the implementation of
   useIsomorphicLayoutEffect requires it. */
function useCombinedRef(...refs) {
    const innerRef = useRef(null);
    useEffect(() => {
        for (const ref of refs) {
            if (!ref) {
                return;
            }
            if (typeof ref === 'function') {
                ref(innerRef.current);
            }
            else {
                ref.current = innerRef.current;
            }
        }
    }, [refs]);
    return innerRef;
}
function usePrevious(value) {
    const ref = useRef();
    useEffect(() => {
        ref.current = value;
    }, [value]);
    return ref.current;
}
function useIsomorphicLayoutEffect(...args) {
    return (isSsr() ? useEffect : useLayoutEffect)(...args);
}

export { useCombinedRef, useIsomorphicLayoutEffect, usePrevious };
//# sourceMappingURL=hooks.js.map
